// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_style_item__31I1f","status":"Item_style_status__2hRdZ","title":"Item_style_title__3JK7B","payStatus":"Item_style_payStatus__2554X","price":"Item_style_price__1yAwX"};